import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer style={{
      borderTop: '1px solid rgba(255,255,255,0.06)',
      background: 'var(--background)',
      padding: '32px 24px',
      marginTop: 'auto',
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: '16px',
      }}>
        {/* Brand */}
        <div>
          <Link to="/" style={{ fontFamily: 'Syne', fontWeight: '800', fontSize: '16px', color: 'var(--sand)', textDecoration: 'none' }}>
            Transport<span style={{ color: 'var(--red)' }}>ily</span>
          </Link>
          <p style={{ fontSize: '12px', color: 'var(--olive)', marginTop: '4px' }}>
            Connecting the Tunisian diaspora
          </p>
        </div>

        {/* Legal links — required by German law */}
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', alignItems: 'center' }}>
          {[
            { to: '/impressum', label: 'Impressum' },
            { to: '/privacy',   label: 'Privacy Policy' },
            { to: '/terms',     label: 'Terms of Service' },
          ].map(link => (
            <Link
              key={link.to}
              to={link.to}
              style={{ fontSize: '13px', color: 'var(--olive)', textDecoration: 'none' }}
              onMouseEnter={e => e.currentTarget.style.color = 'var(--sand)'}
              onMouseLeave={e => e.currentTarget.style.color = 'var(--olive)'}
            >
              {link.label}
            </Link>
          ))}
        </div>

        {/* Copyright */}
        <div style={{ fontSize: '12px', color: 'rgba(245,237,216,0.3)' }}>
          © {new Date().getFullYear()} SBH The Company · Transportily
        </div>
      </div>
    </footer>
  );
}